import {useRouter} from 'next/router'
// Types
import type {RouteParams} from '../types/router'

export type {RouteParams}

const getSingleParamValue = (value: string | string[] | undefined): string | null => {
  if (!value) return null
  return Array.isArray(value) ? value[0] || null : value
}

const getFallbackParamsFromAsPath = (asPath: string | undefined): {
  organizationSlug: string | null
  ballotSlug: string | null
  groupSlug: string | null
  questionSlug: string | null
} => {
  if (!asPath) {
    return {
      organizationSlug: null,
      ballotSlug: null,
      groupSlug: null,
      questionSlug: null,
    }
  }

  const [pathWithoutQuery] = asPath.split('?')
  const pathSegments = pathWithoutQuery.split('/').filter(Boolean)

  if (pathSegments[0] === 'o' && pathSegments.length >= 3) {
    return {
      organizationSlug: pathSegments[1] || null,
      ballotSlug: pathSegments[2] || null,
      groupSlug: pathSegments[3] || null,
      questionSlug: pathSegments[4] || null,
    }
  }

  return {
    organizationSlug: null,
    ballotSlug: null,
    groupSlug: pathSegments[0] || null,
    questionSlug: pathSegments[1] || null,
  }
}

export const useRouteParams = (): RouteParams => {
  const router = useRouter()

  const isReady = router?.isReady || false
  const query = router?.query || {}

  const fallbackParams = getFallbackParamsFromAsPath(router?.asPath)

  const organizationSlug = getSingleParamValue(query.organization_slug) ?? fallbackParams.organizationSlug
  const ballotSlug = getSingleParamValue(query.ballot_slug) ?? fallbackParams.ballotSlug
  const groupSlug = getSingleParamValue(query.group_slug) ?? fallbackParams.groupSlug
  const questionSlug = getSingleParamValue(query.question_slug) ?? fallbackParams.questionSlug
  const entryId = getSingleParamValue(query.entry_id)

  return {
    isReady,
    query,
    organizationSlug,
    ballotSlug,
    groupSlug,
    questionSlug,
    entryId,
  }
}
